// extracted by mini-css-extract-plugin
export default {"container":"blog_container__8jwvt","bg_container":"blog_bg_container__Pr5Bd","form_container":"blog_form_container__bgtx3","title":"blog_title__uiVAM"};